const _excluded = ["children", "href", "linkRef", "target", "rel", "component", "refProp"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
const LinkBase = _ref => {
  let {
      children,
      href = '#',
      linkRef,
      target,
      rel,
      component,
      refProp
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Automatically append rel="noopener" for external links
  // (security fix) if no `rel` was passed
  const linkRel = target === '_blank' && !rel ? 'noopener' : rel;
  const LinkComponent = component || 'a';
  const ref = {
    [refProp || 'ref']: linkRef
  };
  return /*#__PURE__*/React.createElement(LinkComponent, _extends({
    href: href,
    rel: linkRel,
    target: target
  }, ref, rest), children);
};
export default LinkBase;
//# sourceMappingURL=LinkBase.js.map